'use strict';

import { Widgets } from './registry';

const SEARCH_DELAY_MS = 250;
const DEFAULT_MIN_INPUT_LENGTH = 2;

const restoreSelectedOption = ($element, data) => {
    if (data.selectedId === undefined || data.selectedText === undefined) {
        return;
    }

    if ($element.find(`option[value="${data.selectedId}"]`).length > 0) {
        return;
    }

    $element
        .append(new Option(data.selectedText, data.selectedId, true, true))
        .trigger('change');
};

const buildAjaxOptions = (data) => {
    const parameter = data.ajaxParam || 'searchString';

    return {
        url: data.ajaxUrl,
        dataType: 'json',
        delay: SEARCH_DELAY_MS,
        cache: true,
        data: (params) => ({ [parameter]: params.term || '' }),
        processResults: (response) => ({ results: response.items }),
    };
};

Widgets.register('select2', ($element, data) => {
    const options = {
        width: data.ajaxUrl ? 'resolve' : '100%',
        allowClear: data.allowClear !== false && data.allowClear !== 'false',
    };

    if (data.placeholder !== undefined) {
        options.placeholder = data.placeholder;
    }

    if (data.ajaxUrl) {
        options.ajax = buildAjaxOptions(data);
        options.minimumInputLength = data.minInputLength !== undefined
            ? Number(data.minInputLength)
            : DEFAULT_MIN_INPUT_LENGTH;
    }

    if (data.dropdownParent !== undefined) {
        options.dropdownParent = $(data.dropdownParent);
    }

    // select2 throws on allowClear without a placeholder
    if (options.allowClear && options.placeholder === undefined) {
        options.allowClear = false;
    }

    $element.select2(options);

    restoreSelectedOption($element, data);
}, {
    isInitialized: ($element) => $element.hasClass('select2-hidden-accessible'),
});
